module.exports = __webpack_public_path__ + "static/media/Corteva_From_Data_to_Decision-tablet.1bd4d6f5.jpg";